// extracted by mini-css-extract-plugin
export var dark = "styles-module--dark--0bb5e";
export var form = "styles-module--form--7317d";
export var salad = "styles-module--salad--ec0d3";
export var wrapper = "styles-module--wrapper--b0c66";